import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { PrimaryButton } from '../../../components/Button';
import { Chart } from '../../../components/Chart';
import { IconWrapper } from '../../../components/Icon';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
export const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid ${theme.colors.border};
  background: ${theme.colors.level1};
  max-width: 816px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;

export const NoReportContainer = styled(Details)`
  justify-content: center;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-bottom: ${theme.colors.grayscale300} 1px solid;
  width: 100%;
`;

export const Title = styled.h1`
  color: ${theme.colors.grayscale900};
  font-family: inherit;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 44px;
  margin-bottom: 0;
`;

export const MonthlyHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const MonthlyTitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: ${theme.colors.secondary900};
`;

export const MonthlyLastExecution = styled.span`
  color: ${theme.colors.secondary800}
  text-align: right;
  font-size: 9px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.27px;
`;

export const CustomerName = styled.h4`
  color: ${theme.colors.grayscale800};
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
`;

export const PlanHighlights = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 8px;
  padding: 16px;
`;

export const PlanHighlightsContainer = styled.div`
  border-bottom: ${theme.colors.grayscale300} 1px solid;
  align-self: stretch;
`;

export const PlanHighlight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  line-height: 24px;
  font-size: 14px;
`;

export const PlanHighlightTitle = styled.span`
  color: ${theme.colors.secondary800};
`;

export const PlanHighlightContent = styled.span`
  font-weight: 600;
`;

export const Bars = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: 16px;
  padding: 16px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 4px;
  padding: 16px;
  width: 100%;
`;

export const ContactButton = styled(PrimaryButton)`
  width: 100%;
  padding: 10px;
  display: flex;
  align-content: center;
  font-weight: 500;
  line-height: 24px;
  font-size: 16px;
  column-gap: 10px;
`;

export const EditMTUButton = styled(PrimaryButton)`
  padding: 0 16px;
  display: flex;
  column-gap: 8px;
`;

export const MTUChart = styled(Chart)`
  min-height: 437px;
`;

export const MTUChartContainer = styled.div`
  padding: 16px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
`;

export const MTUProgressBar = styled.div`
  width: 256px;
  max-width: 256px;
`;

export const IncludedIcon = styled(IconWrapper)`
  color: ${theme.colors.mainBlue};
`;

export const NoneIncludedIcon = styled(IconWrapper)`
  color: ${theme.colors.red500};
`;
